<div class="dialog-container">
  <mat-card class="no-shadow">
    <mat-card-content class="flex-center">
      @for (name of data.noPhoneNames; track name) {
        <p>No phone number for {{ name | titlecase }}.</p>
      }
      @if (data.type === OperationType.Phone) {
        <a [href]="data.code" class="link" (click)="dialog.closeAll()"
          ><mat-icon>launch</mat-icon>Launch phone app</a
        >
      }
      @if (data.type === OperationType.Text) {
        <a [href]="data.code" class="link" (click)="dialog.closeAll()"
          ><mat-icon>launch</mat-icon>Launch text app</a
        >
      }
    </mat-card-content>
  </mat-card>
</div>
